import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiService } from "../../api/apiService";
import { API_ENDPOINTS } from "../../../constants/apiEndpoints";

export const getMealRecipeCountsAction = createAsyncThunk(
  "mealRecipeCounts/getCounts",
  async (_, thunkAPI) => {
    try {
      const response = await apiService.get(
        API_ENDPOINTS.MEAL_RECIPE_COUNTS.GET
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const updateMealRecipeCountsAction = createAsyncThunk(
  "mealRecipeCounts/updateCounts",
  async (countsData, thunkAPI) => {
    try {
      const response = await apiService.put(
        API_ENDPOINTS.MEAL_RECIPE_COUNTS.UPDATE,
        countsData
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);
